import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCustomer, setStep } from "../../../Reducer/customerSlice";
import NextPrev from "../../../Helpers/Components/NextPrev";
import { toast } from "react-toastify";
import Handler from "../../../Helpers/Components/Handler";
import Select from 'react-select'
import Compressor from 'compressorjs';

const Other = (props) => {
    const customer = useSelector(state => state?.customer?.customer)
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const setSteps = () => {
        props?.page?.kyc ? dispatch(setStep(6)) : dispatch(setStep(5))
    }
    const handleNext = async () => {
        if (customer?.documentId || props?.other?.length) {
            setLoading(true)
            const formData = new FormData();
            let checkFile = props?.other?.length
                && props.other.map((element, i) => {
                    const oldFile = element.file;
                    const newFile = new File([oldFile], i, {
                        type: oldFile.type,
                        lastModified: oldFile.lastModified,
                    });
                    element.file = newFile;
                    return element;
                })
            checkFile?.length && checkFile?.map((element, i) => {
                formData.append(`other`, element?.file)
            })
            formData.append('type', customer?.documentType || "VOTER ID")
            customer?.documentId && formData.append('id', customer?.documentId || "")
            const response = await Handler({ method: 'patch', url: `/customer/details/other/document/update/${props?.customerId}`, data: formData, headers: { 'Content-Type': 'multipart/form-data' } })
            setLoading(false)
            if (response?.success) {
                const photo = response?.data?.other && response?.data?.other?.length ? response?.data?.other?.filter(element => element) : []
                const others = photo?.length ? photo?.map((element, i) => { return { url: element, file: element, id: i } }) : []
                props?.setOther(others)
                dispatch(setStep(8))
            } else {
                toast.error(response?.message)
            }
        } else {
            dispatch(setStep(8))
        }
    }
    const checkFileSize = (file, fieldName, previewKey) => {
        if (file.size > 4.5 * 1024 * 1024) {
            toast.error('Compressed image size exceeds 4.5 MB.');
        } else {
            if (previewKey === "other") {
                props?.setOther((prev) => ([...prev, { file: file, url: URL.createObjectURL(file), id: props?.other?.length }]))
            } else if (previewKey >= 0 || previewKey <= 8) {
                props?.setOther(props?.other?.map((element, i) => { if (i === previewKey) { return { url: URL.createObjectURL(file), id: previewKey, file: file } } else { return element } }))
            }
        }
    };
    const compressImage = (file, fieldName, previewKey) => {
        new Compressor(file, {
            quality: 0.9,
            convertSize: 1 * 1024 * 1024,
            success(result) {
                checkFileSize(result, fieldName, previewKey);
            },
            error(err) {
                toast.error(err.message);
            },
        });
    };
    const handleImage = (event, previewKey) => {
        if (event.target.files[0]) {
            compressImage(event.target.files[0], [event.target.name], previewKey);
        }
    };
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-6 col-xl-4">
                    {
                        props?.other && props?.other?.length > 0 ?
                            props?.other?.map((element, i) => {
                                return (
                                    <div id={i} key={i} className="mb-3">
                                        <div className="main-div">
                                            <div className="btn-div">
                                                <label htmlFor={`other${i}`} className="me-2 upload-btn">Upload</label>
                                                <button className="btn-warning btn btn-sm" onClick={() => { if (element?.url) { props?.setChosen(element?.url); props?.setProof(true) } }}>View</button>
                                            </div>
                                            <img src={element?.url || ""} alt="Other Document" className="kycPhotoImg" />
                                        </div>
                                        <input type="file" accept="image/*" className="d-none" name="other" id={"other" + i} onChange={(event) => handleImage(event, i)} />
                                    </div>
                                )
                            })
                            : ""
                    }
                    {
                        props?.other && props?.other?.length < 8 ?
                            <div className="text-center">
                                <label className="cursor-pointer" htmlFor="other"> <i className='fa-solid fa-plus fs-2'></i> </label>
                                <input type="file" accept="image/*" className="d-none" id="other" onChange={(event) => handleImage(event, 'other')} />
                            </div>
                            : ""
                    }
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label className="form-label"> Choose Document </label>
                        <Select
                            value={customer?.documentType ? { label: customer?.documentType?.toUpperCase(), value: customer?.documentType?.toUpperCase() } : { label: "VOTER ID", value: "VOTER ID" }}
                            onChange={(e) => { dispatch(setCustomer({ documentType: e.value })) }}
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                    boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                    "&:hover": {
                                        borderColor: "#f16436"
                                    }
                                }),
                                option: (style, state) => ({
                                    ...style,
                                    backgroundColor: state.isSelected
                                        ? "#f16436"
                                        : (state.isFocused || state.isActive)
                                            ? "#f164361a"
                                            : "white",
                                    color: state.isSelected ? "white" : "black"
                                })
                            }}
                            isDisabled={loading}
                            options={[
                                { label: "VOTER ID", value: "VOTER ID" },
                                { label: "WORK ID", value: "WORK ID" },
                                { label: "FAMILY CARD", value: "FAMILY CARD" },
                                { label: "COLLEGE ID", value: "COLLEGE ID" },
                                { label: "CHEQUE LEAF", value: "CHEQUE LEAF" },
                                { label: "OTHERS", value: "OTHERS" }
                            ]} className="mb-3" />
                    </div>
                    <div className="mb-3">
                        <label className="form-label" htmlFor="documentId"> Document ID </label>
                        <input autoComplete="off" disabled={loading} id="documentId" type="text" name="documentId" value={customer?.documentId || ""} onChange={(e) => dispatch(setCustomer({ documentId: e.target.value }))} className="form-control input-theme text-uppercase" />
                    </div>
                </div>
            </div>
            <NextPrev step={7} setStep={setSteps} last={7} onClick={handleNext} loading={loading} />

        </React.Fragment>
    )
}

export default Other